<template lang="pug">
div
  .pa-2.mx-1.my-10
    v-row
      v-col.pa-6(cols=12 lg=5)
        v-row(justify="start")
          v-col(cols=10 lg=12)
            div.text-h3.primary--text.font-weight-bold Which EV is for me?
          v-col.mx-2.text-right(cols=1 v-if="mobile")
            v-menu
              template(v-slot:activator="{ on, attrs }")
                v-btn(color="primary"  dark  v-bind="attrs" v-on="on" icon)
                  v-icon mdi-dots-vertical
              v-list
                v-list-item
                  v-btn(v-on:click="routePlanning" block text) Trip Planner
        v-row
          v-col
            div.text-h5.primary--text.font-weight-bold Your regular driving
            div.subtitle-2 Where do you do most of your driving?
        v-row
          v-col.pa-6
            VerticalTripCard(:trip="trip")
            div.pa-6
              v-checkbox(v-model="createReturn" label="Create a return trip")
            div.pa-6
              p How often do you do this trip?
              v-row(align="baseline")
                  v-col(cols=12 sm=4)
                      v-select(":items"="amounts" v-model="trip.frequency" outlined attach)
                  v-col(cols=12 sm=4)
                      span(class="per") time{{ trip.frequency > 1 ? 's':''}} per
                  v-col(cols=12 sm=4)
                      v-select(":items"="units" v-model="trip.frequencyUnit" outlined attach)
            v-row(justify="center" v-if="!mobile")
              v-col(cols=8)
                v-row(justify="center")
                  v-btn.primary.my-10(v-on:click="drivingDetails", block) Find My EV!
      v-col.pa-6(cols=12 lg=1)
        v-spacer
      v-col.pa-6(cols=12 lg=5 )
        v-row.mt-1(justify="end" v-if="!mobile")
          v-col(cols=3)
            v-btn(v-on:click="routePlanning" block outlined elevation=1) Trip Planner
        v-row
          v-col
            div.text-h5.primary--text.font-weight-bold Your current car
            div.subtitle-2 Compare an EV to what you currently drive
        v-row
          v-col
            WhatDoYouDrive.ma-0.pa-1(
              @next="nextTab(1)",
              @skip="skipTab(0)",
              :bubble="bubble",
              :settings="settings"
            )
        v-row(justify="center" v-if="mobile")
          v-col(cols=8)
            v-row(justify="center")
              v-btn.primary.my-10(v-on:click="drivingDetails", block) Find My EV!


    v-row(align="center", justify="end")
      v-col(cols=3)
        v-spacer
        em(style="font-size: 0.8em;margin-left:5px;") Powered by
        v-img(src="https://powersell.appstack.me/logo.png", width=100)
</template>

<script>
import VerticalTripCard from "../components/VerticalTripCard";
import WhatDoYouDrive from "../components/WhatDoYouDrive.vue";
import Vue from 'vue';
export default {
  components: { VerticalTripCard, WhatDoYouDrive },
  data() {
    return {
      bubble: this.$bubble,
      settings: this.$dealer.user_settings,
      createReturn: false,
      amounts: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31
      ],
      units: ["day", "workday", "week", "fortnight", "month", "year"],
      trip: {
        id: 1,
        title: "My Trip",
        frequency: 1,
        frequencyUnit: "workday",
        viaAddresses: [],
        fromAddress: { Address: null },
        toAddress: { Address: null },
        path: [],
      },
    };
  },
  mounted() {
    if (this.$route.query.state) {
      let state = this.$route.query.state;
      let loadState = this.loadState;
      setTimeout(function () {
        loadState(state);
      }, 1000);
    }
        Vue.prototype.$Countly.q.push([
      "add_event",
      {
        key: "Trips Landing Page",
        segmentation: {
          dealer: this.$dealer.default_settings.name,
        },
      },
    ]);
  },
  methods: {
    drivingDetails() {
      this.$trips.push(this.trip);
      if (this.createReturn) {
        this.makeReturn(this.trip);
      }
      this.$router.push("recommender/2");
    },
    routePlanning() {
      this.$router.push("planner");
    },
    regularTrips() {
      this.$router.push("recommender/1");
    },
    dealerAdmin() {
      this.$router.push("dealer");
    },
    makeReturn(trip) {
      let newTrip = JSON.parse(JSON.stringify(trip));
      console.log(trip);
      newTrip.viaAddresses = newTrip.viaAddresses.reverse();
      let from = newTrip.fromAddress;
      newTrip.fromAddress = newTrip.toAddress;
      newTrip.toAddress = from;
      let index = this.$trips.findIndex(function (value) {
        return trip.id == value.id;
      });
      newTrip.id = 101 + trip.id;
      this.$trips.splice(index + 1, 0, newTrip);
    }
  },
};
</script>

<style scoped>
.v-card > h2,
.subtitle {
  color: #1e88e5;
  font-weight: bold;
}
a {
  text-decoration: none;
}
.right {
  float: right;
}
.v-card p {
  text-align: center;
}
.v-card .v-image {
  transform: translate(-50%, 0);
  left: 50%;
  opacity: 0.6;
}
.icon-image {
  opacity: 0.5;
  float: right;
}
.white {
  filter: invert(1);
  mix-blend-mode: lighten;
}
</style>